/*
 * providers
 */
import { DevProvider } from "@timeprox/core/dev"
import { ThemeProvider } from "@timeprox/core/theme"
import { ErrorBoundary, NetworkToast } from "@timeprox/react/components"
import { Toaster } from "@timeprox/react/ui"
import { ReactNode } from "react"

type ProvidersProps = {
	children: ReactNode
}

export default function Providers({ children }: ProvidersProps) {
	return (
		<ErrorBoundary>
			<DevProvider>
				<ThemeProvider>
					{children}
					<Toaster />
					<NetworkToast />
				</ThemeProvider>
			</DevProvider>
		</ErrorBoundary>
	)
}
